import { useEffect, useRef, useState } from "react";

const useSpeechRecognition = () => {
  const activeInput    = useRef(null);
  const recognitionRef = useRef(null);
  const [listening, setListening]   = useState(false);

  useEffect(() => {
    // ── Suivi de l'input focusé ──────────────────────────────
    const handleFocus = (e) => {
    if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
    ) {
        activeInput.current = e.target;
    }
    };

    document.addEventListener("focusin", handleFocus);

    // ── Initialisation Web Speech API ────────────────────────
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.warn("Web Speech API non supportée sur ce navigateur.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "fr-FR";
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (e) => {
        const transcript = e.results[0][0].transcript;
        if (activeInput.current) {
            const proto = activeInput.current.tagName === "TEXTAREA"
            ? window.HTMLTextAreaElement.prototype
            : window.HTMLInputElement.prototype;

            const nativeValueSetter = Object.getOwnPropertyDescriptor(proto, "value").set;
            
            // Concatène au lieu de remplacer
            const currentValue = activeInput.current.value;
            const newValue = currentValue ? currentValue + "\n" + transcript : transcript;
            nativeValueSetter.call(activeInput.current, newValue);

            const tracker = activeInput.current._valueTracker;
            if (tracker) tracker.setValue("");

            activeInput.current.dispatchEvent(new Event("input", { bubbles: true }));
            activeInput.current.dispatchEvent(new Event("change", { bubbles: true }));
        }
    };

    recognition.onend  = () => setListening(false);
    recognition.onerror = () => setListening(false);

    recognitionRef.current = recognition;

    return () => document.removeEventListener("focusin", handleFocus);
  }, []);

  const startListening = () => {
    if (!recognitionRef.current || !activeInput.current) return;
    recognitionRef.current.start();
    setListening(true);
  };

  const stopListening = () => {
    if (!recognitionRef.current) return;
    recognitionRef.current.stop();
    setListening(false);
  };

  return { listening, startListening, stopListening };
};

export default useSpeechRecognition;